export class DynamicTabPageConfig {
  public static EndPoint = {
    Page: {
      getActivePage: '/platform/page-designer/pageversion/{id}',
      getPage: '/platform/page-designer/page',
      getPageById: '/platform/page-designer/page/{id}',
      getResponseByPageId: '/solution/formresponse/{responseId}/getByPageId/{pageId}',
      createFormResponse: '/solution/formresponse/create',
      patchFormResponse: '/solution/formresponse',
      updateFormResponse: '/pagedata/'
    },
    Narrative: {
      getIncidentListById: '/incident/listBySourceId/{id}'
    },
    Notification: {
      createSurveyConfig: '/surveyconfig/usersurvey/{id}/{status}/{pagedataid}'
    },
    Finance: {
      exportDocument: '/integrated/exportDocuments/',
      uploadDocument: 'document/upload',
      getUniqueId: '/uniqueIdLogic/'
    },
    Attachments: {
      createAttachment: '/solution/formresponse-attachment/create'
    },
    youthSummary:{
      getDetails: '/solution/youth-summary',
      getRiskValue: '/solution/youth-summary/getRiskValue',
      getAlertCount: '/solution/youth-summary/getAlertCount'
  }
  };
}
